import React from 'react';
import { observer } from 'mobx-react';
import { WeaInput } from 'ecCom';

interface Props {
    value?: string;
    valueSpan?: string;
    viewAttr:string;
    onBlur: (string) => void;
    ecId?:string;
}

export default observer((props: Props) => {
    const { onBlur,viewAttr} = props;


    return (
        <div style={{float:'left'}}>
            <WeaInput ecId={`${props && props.ecId || ''}_WeaInput@wpjhc6`}
                viewAttr={viewAttr}
                value={props.value || ""}
                onBlur={onBlur} />
        </div>
    )
});



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/Input.tsx